import { Component } from '@angular/core';
import { ViewChild, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Role } from '../shared/role';
import { RoleService } from '../shared/role.service';

import { ConfirmationService } from 'primeng/primeng';

@Component({

    selector: 'role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit, OnDestroy {
    @Input() role: Role;
    @Input() id: number;
    @Input() operation: string;
    
    @ViewChild('formElement') formElement;
    @ViewChild('form') form;
    @Output() formSubmited = new EventEmitter();

    fromRoute: boolean;

    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;
    submittingForm: boolean = false;


    constructor(public rootService: RootService,
        public roleService: RoleService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {



    }
    ngOnChanges() {
        if (this.operation == 'read' || this.operation == 'update') {
            if (typeof this.id !== 'undefined') {
                this.getRole(+this.id);
            }
        } else {
            if (typeof this.id !== 'undefined') {
                this.refreshRequest();
            }

        }
    }
    getRole(id: number) {
        this.role = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.roleService.get(id)
            .subscribe(
            items => {
                if (items.roles && items.roles.length > 0) {
                    this.role = items.roles[0];
                } else {
                    this.noResult = true;
                }
                


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getClone(id: number) {
        this.role = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.roleService.getClone(id)
            .subscribe(
            items => {

                if (items.role) {
                    this.role = items.role;
                } else {
                    this.noResult = true;
                }
                


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getInfo() {
        if (!this.role) {
            this.role = {
                
            };
        }
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.roleService.getInfo()
            .subscribe(
            items => {
                


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    deleteRole() {
        this.confirmationService.confirm({
            message: this.translate.instant('form.common.deleteQ', { 'item': this.translate.instant('ctrl.role.view.header.one') }),
            header: this.translate.instant('form.common.delete'),
            icon: 'fa fa-trash',
            accept: () => {
                this.roleService.delete(this.role._id)
                    .subscribe(
                    items => {
                        this.rootService.toast.showSuccess(this.translate.instant('form.common.deleteItem', { 'item': this.translate.instant('ctrl.role.view.header.one') }));
                        this.formSubmited.emit(this.operation);

                    }, //Bind to view
                    err => {
                        this.rootService.toast.showErrorCode(err.code);
                    });
            }
        });
    }
    
    removeArray(array, index) {
        array.splice(index, 1);
    }
    submitForm() {
        var formElement = this.formElement;
        var form = this.form;
        if (form.invalid) {
            var firstElement = formElement.nativeElement.querySelector('.ng-invalid');
            var focusElement = firstElement.querySelector('.focusV');
            if (focusElement) {
                focusElement.focus();
            }
            return;
        }
        if(this.submittingForm){
            return;
        }
        this.submittingForm=true;
        if (this.operation == 'create' || this.operation == 'clone') {
            this.roleService.create(this.role).subscribe(items => {
                this.rootService.toast.showSuccess(this.translate.instant('form.common.createItem', { 'item': this.translate.instant('ctrl.role.view.header.one') }));
                this.submittingForm=false;
                this.formSubmited.emit(this.operation);
            }, err => {
                this.rootService.toast.showErrorCode(err.code);
                this.submittingForm=false;
            });
        } else if (this.operation == 'update') {
            this.roleService.update(this.id, this.role).subscribe(items => {
                this.rootService.toast.showSuccess(this.translate.instant('form.common.updateItem', { 'item': this.translate.instant('ctrl.role.view.header.one') }));
                this.submittingForm=false;
                this.formSubmited.emit(this.operation);
            },err => {
                this.rootService.toast.showErrorCode(err.code);
                this.submittingForm=false;
            });
        }
    }

    refreshRequest() {
        if (this.operation == 'create') {
            this.getInfo();
        } else if (this.operation == 'clone') {
            this.getClone(this.id);
        } else {
            this.getRole(this.id);
        }
    }
    ngOnInit() {
        if (typeof this.id !== 'undefined' && this.id != null) {
            if (this.operation == 'clone') {
                this.getClone(+this.id);
            } else {
                this.getRole(+this.id);
            }
        } else if(this.operation == 'create'){
            this.getInfo();
        }


    }
    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/module/role/role/role.component.ts